import React from 'react';
import styled from 'styled-components';
import { Checkbox, Input } from '@carvana/showroom-forms';
import { cvBreakpoint768 } from '@carvana/theme';

const Wrapper = styled.div`
  position: relative;
`;

const CheckboxWrapper = styled.div`
  border-left: 1px solid ${props => props.theme.carvana.gray.light};
  display: grid;
  height: 44px;
  padding: 0 8px;
  place-items: center;
  position: absolute;
  right: 0;
  top: 8px;
  color: ${props => props.theme.carvana.gray.dark};

  @media (min-width: ${cvBreakpoint768}px) {
    padding: 0 37px;
  }
`;

const CheckBoxText = styled.span`
  font-size: 16px;
  font-weight: normal;
  color: ${props => props.theme.carvana.grayThree};
`;

type Props = {
  value?: string;
  checked?: boolean;
  onChange: (e?: any) => void;
  onBlur: (e?: any) => void;
  onClick: (e?: any) => void;
  touched?: boolean;
  error?: string;
  overrideLabel?: string;
  id?: string;
  checkboxId?: string;
};

const MiddleNameV2 = ({
  value,
  checked,
  onChange,
  onBlur,
  onClick,
  touched,
  error,
  overrideLabel,
  id,
  checkboxId,
  ...rest
}: Props) => {
  return (
    <Wrapper>
      <Input
        data-cv-test="middleName"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        touched={touched}
        error={error}
        id={id || 'middleName'}
        label={checked ? 'Middle Name' : 'Middle Name'}
        maxLength={30}
        {...rest}
      />
      <CheckboxWrapper>
        <Checkbox
          id={checkboxId || 'middleNameCheckbox'}
          label={<CheckBoxText>NONE</CheckBoxText>}
          checked={checked}
          onClick={onClick}
        />
      </CheckboxWrapper>
    </Wrapper>
  );
};

export default MiddleNameV2;
